import { useMemo } from "react";
import BeeLight from "../../assets/BEE _ICON _WHITE.png";
import BeeDark from "../../assets/BEE.png";
import { useSelector } from "react-redux";
import { getAgentBranding } from "app/redux/features/agent-branding";
import { getSessionStore } from "app/utils/sessionStore";
import { THEME } from "app/utils/types";

const Footer = () => {
  const theme = getSessionStore("globalTheme");
  const { settingThemeData } = useSelector(getAgentBranding);
  const isDark = useMemo(() => theme === THEME.DARK, [settingThemeData?.body?.theme]);

  // If you change image height and text size then change the "footerHeight" in utils also,
  // it should be in rem and calculated when "data-font" is 'regular' or html font size is 16px.
  return (
    <div className="mt-auto flex flex-col justify-center items-center py-2">
      <div className="w-full flex items-center gap-3 px-3">
        <div className="flex-1 h-[2px] bg-gradient-to-r from-gray-600 via-gray-400/50 to-transparent" />
        <div className="flex items-center gap-2 text-xs font-semibold text-gray-600">
          <img src={isDark ? BeeLight : BeeDark} alt="IAPP Logo" className="!h-6 !w-6" />
          <span className="shrink-0 text-lg !font-normal conthrax-font-light">Powered by IAPP</span>
        </div>
        <div className="flex-1 h-[2px] bg-gradient-to-l from-gray-600 via-gray-400/50 to-transparent" />
      </div>
      <div className="text-center pt-2 text-sm text-gray-500 conthrax-font">
        Insurance Advanced Planning Platform, LLC | {new Date().getFullYear()} All Rights Reserved
      </div>
    </div>
  );
};
export default Footer;
